// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BaseComponent } from '../../../../../com/MetaPattern/MDA/MD/Base/BaseComponent';
import { BEComponent } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { DBTable } from './DBTable';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { DBComponentExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/DBModel/DBComponentExtend';
/**
 * 数据库模型组件 实体类
 * 数据库模型组件，定义数据库模型
 */
export class DBComponent extends BaseComponent {
  /** 绑定实体组件 的ID */
  private _bindingBEComponent_ID: string;

  /** 获取：绑定实体组件 的ID */
  public get bindingBEComponent_ID() {
    return this._bindingBEComponent_ID;
  }

  /** 设置：绑定实体组件 的ID */
  public set bindingBEComponent_ID(value: string) {
    this._bindingBEComponent_ID = value;
  }

  /** 绑定实体组件  */
  private _bindingBEComponent: BEComponent;

  /** 获取：绑定实体组件  */
  public get bindingBEComponent() {
    return this._bindingBEComponent;
  }

  /** 设置：绑定实体组件  */
  public set bindingBEComponent(value: BEComponent) {
    this._bindingBEComponent = value;
    if (value !== null) {
      this.bindingBEComponent_ID = value.id;
    } else {
      this.bindingBEComponent_ID = '';
    }
  }

  /** 数据库表 */
  private _tables: Array<DBTable>;

  /** 获取：数据库表 */
  public get tables() {
    return this._tables;
  }

  /** 设置：数据库表 */
  public set tables(value: Array<DBTable>) {
    this._tables = value;
  }

  constructor() {
    super();
    DBComponentExtend.Init(this);
    this._bindingBEComponent_ID = '';
    this._bindingBEComponent = null;
    this._tables = new Array<DBTable>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: DBComponent, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.bindingBEComponent_ID = element.bindingBEComponent_ID;
      if (hasReference && element.bindingBEComponent !== null) {
        this.bindingBEComponent = element.bindingBEComponent;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.bindingBEComponent_ID = json.BindingBEComponent_ID;
    // if (json.BindingBEComponent !== null) {
    //   this.bindingBEComponent = BEComponent.Create(json.BindingBEComponent);
    // }
    if (json.Tables && json.Tables.length > 0) {
      json.Tables.forEach((element: any) => {
        const dBTable = DBTable.Create(element);
        // dBTable.component = this;
        this.tables.push(dBTable);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.BindingBEComponent_ID = this.bindingBEComponent_ID;
    if (this.tables && this.tables.length > 0) {
      json.Tables = [];
      this.tables.forEach((element) => {
        json.Tables.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'bindingBEComponent', '绑定实体组件', EnumDataType.Reference, this.bindingBEComponent, true, '绑定实体组件', 'BEComponent', '');
    return context;
  }

  static Create(json: any): DBComponent {
    const dBComponent = new DBComponent();
    dBComponent.Deserialize(json);
    dBComponent.json = json;
    return dBComponent;
  }
}
